import * as React from "react";

interface ProgressBarProps {
    bgColor: string;
    value: number;
    max: number
}

export const ProgressBar: React.FC<ProgressBarProps> = ({bgColor, value, max}) => {

    const maxVal = max === 0 ? 0 : max;
    const fillerStyles: React.CSSProperties = {
        width: value === 0 ? `2%` : `${(value * 100) / maxVal}%`,
        backgroundColor: bgColor,
    }


    return (
        <div className={"progress-bar-container"}>
            <div className={"progress-bar-fill skeleton"} style={fillerStyles}>
                {/*<span className={'progress-bar-label'}>{value > 0 ? "In progress" : ""}</span>*/}
            </div>
        </div>
    );
};
